import _toLower from 'lodash/toLower';
import * as Sentry from '@sentry/react';
import { createBrowserHistory } from 'history';

const ENV = import.meta.env.VITE_ENV;
const isDevelopment = ENV === 'DEVELOPMENT';

export const history = createBrowserHistory();

if (!isDevelopment) {
  const defaultOptions = {
    dsn: 'https://0eb1568ea93c4679bcee693ea86dff1a@o4511712814366720.ingest.us.sentry.io/5774579',
    integrations: [Sentry.reactRouterV5BrowserTracingIntegration({ history })],
    environment: _toLower(ENV),
    tracesSampleRate: 1.0,
  };
  const mergedOptions = {
    ...defaultOptions,
    ...(ENV === 'PRODUCTION'
      ? {
          beforeSend(event, hint) {
            const originalError = hint ? hint.originalException : null;
            if (originalError) {
              if (originalError.errorCode === 20104) return null;
              if (originalError.status === 0 && originalError.code === 0)
                return null;
            }

            const exceptionValues = event.exception?.values || [];
            const exceptionText = exceptionValues
              .map((e) => `${e.type || ''} ${e.value || ''}`)
              .join(' ');
            const lowMsg =
              `${event.message || ''} ${exceptionText}`.toLowerCase();

            if (lowMsg.includes('disconnected (status: 0, code: 0)')) {
              return null;
            }

            // Browser extensions often JSON.stringify DOM nodes / React fibers
            // (CAREIT-DASHBOARD-46P circular structure on /auth/login).
            if (
              lowMsg.includes('converting circular structure to json') &&
              (lowMsg.includes('htmlanchorelement') ||
                lowMsg.includes('html') ||
                lowMsg.includes('reactfiber') ||
                lowMsg.includes('__reactfiber'))
            ) {
              return null;
            }

            // Check if the stacktrace exists and has frames
            if (event.exception && event.exception.values) {
              for (const exception of event.exception.values) {
                if (exception.stacktrace && exception.stacktrace.frames) {
                  for (const frame of exception.stacktrace.frames) {
                    // Check if the frame's filename originates from 'https://maps.googleapis.com'
                    if (
                      frame.filename &&
                      frame.filename.startsWith('https://maps.googleapis.com')
                    ) {
                      return null; // Drop the event and don't send to Sentry
                    }
                  }
                }
              }
            }

            if (event.exception && !event.contexts?.feedbackDialog?.hide) {
              Sentry.showReportDialog({ eventId: event.event_id });
            }
            return event;
          },
        }
      : {}),
  };

  Sentry.init(mergedOptions);
}
